import { Navigate } from "react-router-dom";
import { useAuthStore } from "src/store/authStore";

export default function DefaultLayout() {
  const { authToken } = useAuthStore();

    // ✅ Single check protects ALL routes in this group
  if (authToken) {
    return <Navigate to="/dashboards" replace />;
  } else {
    return <Navigate to="/users/sign_in" replace />;
  }
}
